import React from 'react';
import { ShieldAlert, Zap, FileCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function ComplianceSafety() {
  const cards = [{
    icon: ShieldAlert,
    title: 'Smoke Alarm Compliance',
    desc: 'WA Building Regulations require working smoke alarms. We install, test and certify.'
  }, {
    icon: Zap,
    title: 'RCD Compliance',
    desc: 'Two working RCDs required on every WA residential property. We test, replace, certify.'
  }, {
    icon: FileCheck,
    title: 'Safety Certificates',
    desc: 'Pre-sale, pre-rent, or post-renovation electrical compliance certificates issued.'
  }];
  return <section className="py-20 lg:py-28 bg-cream relative overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-3">
          <span className="text-accent font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-4">
            Legal & Safety
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6 tracking-tighter" data-id="element-5">
            WA Compliance & Safety, sorted.
          </h2>
          <p className="text-lg text-slate leading-relaxed" data-id="element-6">
            Selling, renting out, or renovating? We handle the legal stuff so
            you don't have to.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-7">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white border border-gray-100 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all flex flex-col items-center text-center group" data-id="element-8">
              <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-9">
                <card.icon className="w-8 h-8 text-accent" data-id="element-10" />
              </div>
              <h3 className="text-xl font-heading font-extrabold text-navy mb-3" data-id="element-11">
                {card.title}
              </h3>
              <p className="text-slate text-sm leading-relaxed" data-id="element-12">{card.desc}</p>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-13">
          <a href="#quote" className="bg-navy hover:bg-navy-600 text-white px-8 py-4 rounded-xl font-extrabold text-lg transition-all shadow-lg hover:-translate-y-1" data-id="element-14">
            Book a compliance check
          </a>
        </div>
      </div>
    </section>;
}